import script from "./ComplaintsBook.vue?vue&type=script&setup=true&lang=js"
export * from "./ComplaintsBook.vue?vue&type=script&setup=true&lang=js"

import "./ComplaintsBook.vue?vue&type=style&index=0&id=d3c5fb24&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d3c5fb24"]])

export default __exports__